import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {
  BEDWETTING_TYPE_VALUE,
  CHART_LEGENDS_ICON,
} from "pages/graph/constants";
import moment from "moment";


const ChartEvent = ({ data, startTime, endTime }) => {
  const { t } = useTranslation();
  const [chartData, setChartData] = useState([]);

  const toLocalTime = (utcTime) => {
    return (new Date(utcTime)).getTime() - ((new Date(utcTime)).getTimezoneOffset() * 60 * 1000)
  }

  const toLocalTimeSub = (utcTime, day) => {
    var date = new Date(utcTime);
    let hour = date.getHours();
    if (hour < 15) {
      day = 0;
    }
    date.setDate(date.getDate() - day);
    return (new Date(date)).getTime() - ((new Date(date)).getTimezoneOffset() * 60 * 1000)
  }

  useEffect(() => {
    if (data.length) {
      const parsedData = [];
      for (const item of data) {
        if (item.wakeup_time || item.wakeup_time_sensor) {
          parsedData.push({
            x: toLocalTime(item.wakeup_time || item.wakeup_time_sensor),
            y: 1,
            marker: {
              symbol: `url(${getIcon(item, 'wakeup_time')})`,
              width: 40,
              height: 40,
            },
            title: t("graph.wakeUpTime")
          })
        }

        if (item.memo_time || item.memo_time_sensor) {
          parsedData.push({
            x: toLocalTimeSub(item.memo_time || item.memo_time_sensor, 1),
            y: 1,
            marker: {
              symbol: `url(${getIcon(item, "memo_time")})`,
              width: 40,
              height: 40,
            },
            title: t("graph.toiletTime")
          });
        }

        if (item.sleep_time || item.sleep_time_sensor) {
          parsedData.push({
            x: toLocalTimeSub(item.sleep_time || item.sleep_time_sensor, 1),
            y: 1,
            marker: {
              symbol: `url(${getIcon(item, "sleep_time")})`,
              width: 40,
              height: 40,
            },
            title: t("graph.sleepTime")
          });
        }

        if (item.bed_wetting_time || item.bed_wetting_time_sensor) {
          let title = "";
          if (
            item.bed_wetting_type ===
            BEDWETTING_TYPE_VALUE
              .the_alarm_went_off_and_I_woke_up_to_stop_it.value
          ) {
            title = item.is_bed_wetting_to_toilet
              ? t("graph.waterDotBluer")
              : t("graph.waterBluer");
          } else if (
            item.bed_wetting_type ===
            BEDWETTING_TYPE_VALUE
              .the_alarm_went_off_but_I_couldnt_wake_up_by_myself.value
          ) {
            title = item.is_bed_wetting_to_toilet
              ? t("graph.waterDot")
              : t("graph.water");
          }
          parsedData.push({
            x: toLocalTimeSub(item.bed_wetting_time || item.bed_wetting_time_sensor, 1),
            y: 1,
            marker: {
              symbol: `url(${getIcon(item, "bed_wetting_time")})`,
              width: 40,
              height: 40,
            },
            title: title
          });
        }
      }
      setChartData(parsedData);
    }
  }, [data]);

  const getIcon = (item, key) => {
    if (key == "wakeup_time") {
      return CHART_LEGENDS_ICON.wakeUpTime;
    }

    if (key == "memo_time") {
      return CHART_LEGENDS_ICON.toiletTime;
    }

    if (key == "sleep_time") {
      return CHART_LEGENDS_ICON.sleepTime;
    }

    if (key == "bed_wetting_time") {
      if (
        item.bed_wetting_type ===
        BEDWETTING_TYPE_VALUE
          .the_alarm_went_off_and_I_woke_up_to_stop_it.value
      ) {
        return item.is_bed_wetting_to_toilet
          ? CHART_LEGENDS_ICON.waterDotBluer
          : CHART_LEGENDS_ICON.waterBluer;
      }

      if (
        item.bed_wetting_type ===
        BEDWETTING_TYPE_VALUE
          .the_alarm_went_off_but_I_couldnt_wake_up_by_myself.value
      ) {
        return item.is_bed_wetting_to_toilet
          ? CHART_LEGENDS_ICON.waterDot
          : CHART_LEGENDS_ICON.water;
      }
    }
  }

  const options = {
    title: {
      text: "",
    },
    chart: {
      type: "scatter",
      height: 150,
      marginLeft: 100,
      marginTop: 0,
      //   style: {
      //     borderTop: "1px solid black",
      //   },
    },
    xAxis: {
      type: "datetime",
      tickWidth: 0,
      tickInterval: 30 * 60 * 1000, // 30 minutes in milliseconds
      gridLineWidth: 2,
      gridLineDashStyle: "dot",
      lineWidth: 2,
      labels: {
        rotation: -90,
        useHTML: true,
        autoRotation: false,
        style: {
          whiteSpace: 'nowrap',
          textOverflow: 'unset',
          overflow: 'visible',
          fontSize: '10px',
        },
        formatter: function () {

          const minute = new Date(this.value).getMinutes();
          if (minute !== 0) {
            return "";
          }
          return Highcharts.dateFormat("%H:%M", this.value);
        },
        overflow: "justify",
        rotation: 0,
      },
      min: startTime, // 6:30 PM today
      max: endTime, // 9:30 AM tomorrow
      margin: 10,
    },
    yAxis: {
      title: {
        text: t("graph.tempePosi.event"),
        rotation: 0,
        style: {
          fontSize: 16,
          color: "#000000",
          fontWeight: "bold",
        },
        x: -60,
      },
      labels: {
        enabled: false,
      },
      min: 0,
      max: 2,
      lineColor: "black",
      lineWidth: 2,
    },
    series: [
      {
        name: t("graph.tempePosi.event"),
        color: "rgba(223, 83, 83, .5)",
        data: chartData,
      },
    ],
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          //   enabled: true,
        },
      },
      line: {
        marker: {
          enabled: false,
        },
      },
    },
    tooltip: {
      formatter: function () {
        const x = this.x;
        const formattedX = moment(new Date(x)).utc().format("YYYY-MM-DD HH:mm");
        const title = this.point.options.title;

        return `<text x="8" data-z-index="1" y="18" style="color: rgb(51, 51, 51);fill: rgb(51, 51, 51);"><tspan style="color: rgba(223, 83, 83, 0.5); fill: rgba(223, 83, 83, 0.5);">●</tspan> <tspan> ${title}</tspan><tspan class="highcharts-br" dy="15" x="8">​</tspan>${t("graph.tempePosi.time")}: <tspan style="font-weight: bold;">${formattedX}</tspan><tspan class="highcharts-br">​</tspan></text>`;
      }
    },
  };
  return (
    <div className="chart-event">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default ChartEvent;
